module.exports = __webpack_public_path__ + "static/3-5d8dcc948e562d6ab96b44001d99db2a.jpg";